import { useMemo } from "react";
import useUser from "../../hooks/useUser";

const FORM_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSeZjs5lOi4KmaVMjkpFWZzJIA5Gh_Yxwb5rKyVwcCJBqytBgw/viewform?usp=pp_url';
const EMAIL_FIELD = '&entry.1993621467';
const URL_FIELD = '&entry.2018527742';

const GoogleForm = () => {
  const user = useUser();
  const form = useMemo(() =>  FORM_LINK + `${EMAIL_FIELD}=${user?.email}${URL_FIELD}=${window.location.href}`, [user])

  return (
    <iframe
      src={form}
      width='100%'
      height='100%'
      title='Google Form'
    >
      Loading…
    </iframe>
  );
}

export default GoogleForm;
